// extracted by mini-css-extract-plugin
export var isMobile = "pageLayoutNav-module--isMobile--569d5";
export var nav = "pageLayoutNav-module--nav--7dce7";